import styles from './MobilePanel.module.css';

// Full-height container for the active mobile panel. No title bar or close
// button: the highlighted tab in MobileTabBar names the panel, and every
// available panel always has a tab, so there is nothing to close.
export default function MobilePanel({ children }) {
  return <div className={styles.panel}>{children}</div>;
}
